export const GET_SELECTED_TAB= 'GET_SELECTED_TAB'
export const loadLoginSelectedTab=()=>({
    type:GET_SELECTED_TAB,
})
export const SAVE_SELECTED_TAB= 'SAVE_SELECTED_TAB'
export const saveLoginSelectedTab=(_tabNumber:number)=>({
    type:SAVE_SELECTED_TAB,
    payload: _tabNumber
})